/*
* COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.

* This software is only to be used for the purpose for which it has been
* provided. No part of it is to be reproduced, disassembled, transmitted,
* stored in a retrieval system nor translated in any human or computer
* language in any way or for any other purposes whatsoever without the
* prior written consent of HSBC Holdings plc.

*/

import React from 'react';
import PropTypes from 'prop-types';

const FileDesc = (props) => {
    const { content, onhandleChange } = props;
    return (
        <div className="tips-txt">
            <h5 data-key="pdftips">{content.title[0]}</h5>
            <p data-key="pdftipsTip">{content.title[1]}</p>
            <div className="pdf-download clearfix">
                <div className="pdf-download-txt clearfix">
                    {content.file}
                    <span onClick={onhandleChange}>[{content.fileTip}]</span>
                    <i className='icon icon-chevron-right'></i>
                </div>
            </div>
        </div>
    );
};

FileDesc.propType = {
    content: PropTypes.object.isRequired,
    onhandleChange: PropTypes.func.isRequired
};
export default FileDesc;


// WEBPACK FOOTER //
// ./src/views/FileUploadInfo/components/child/FileDesc.js